import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BaseItemDialog__section flex-1" }
const _hoisted_2 = { class: "BaseItemDialog__section-header bg-white q-mb-12" }
const _hoisted_3 = { class: "fs-15px fw-600 text-cool-gray-100 block q-mb-sm" }
const _hoisted_4 = { class: "BaseItemDialog__section-body flex column no-wrap gap-12" }
const _hoisted_5 = { class: "q-px-sm q-py-xs flex no-wrap items-center justify-between" }
const _hoisted_6 = { class: "fs-15px text-cool-gray-70" }
const _hoisted_7 = { class: "fs-15px text-cool-gray-100 text-right" }
const _hoisted_8 = { class: "q-px-sm q-py-xs flex no-wrap items-center justify-between" }
const _hoisted_9 = { class: "fs-15px text-cool-gray-70" }
const _hoisted_10 = { class: "fs-15px text-cool-gray-100 text-right" }
const _hoisted_11 = { class: "q-px-sm q-py-xs flex no-wrap items-center justify-between" }
const _hoisted_12 = { class: "fs-15px text-cool-gray-70" }
const _hoisted_13 = { class: "fs-15px text-cool-gray-100 text-right" }

import translate from 'src/common/helpers/language/translate'
import { IItemView } from 'src/common/interfaces'
import globalTranslateObject from 'src/translate/global.translate'

interface IProps {
  item: IItemView
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogUnits' },
  __name: 'BaseItemDialogUnits',
  props: {
    item: {}
  },
  setup(__props: any) {




const { t: globalT } = translate(globalTranslateObject)

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(globalT)('units')), 1),
      _createVNode(_component_k_divider, { size: "md" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(globalT)('Inventory')), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.item.inventory_unit_str), 1)
      ]),
      _createVNode(_component_k_divider, {
        dotted: true,
        color: "cool-gray-50"
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(globalT)('purchase')), 1),
        _createElementVNode("span", _hoisted_10, _toDisplayString(__props.item.purchase_unit_str), 1)
      ]),
      _createVNode(_component_k_divider, {
        dotted: true,
        color: "cool-gray-50"
      }),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(globalT)('sales')), 1),
        _createElementVNode("span", _hoisted_13, _toDisplayString(__props.item.sell_unit_str), 1)
      ])
    ])
  ]))
}
}

})